import type { Dispatch, SetStateAction } from 'react';
import { createNamedContext } from '@trinity/chat-components';
import type { ReducedFiltersContextValue } from './interfaces';
import { TranscriptHighlightItem } from '@trinity/chat';

export const ReducedFiltersContext = createNamedContext<ReducedFiltersContextValue>(undefined, 'WorkspaceGlobalSearch.ReducedFilters.Context');
export const RowExpandedContext = createNamedContext<[boolean, Dispatch<SetStateAction<boolean>>]>(null, 'WorkspaceGlobalSearch.RowExpanded.Context');
export const TranscriptHighlightsContext = createNamedContext<TranscriptHighlightItem[]>([], 'WorkspaceGlobalSearch.TranscriptHighlights.Context');